<template>
  <div>
    <el-card shadow="never" header="Edit">
      <el-form
        ref="editForm"
        label-position="top"
        :rules="editRules"
        :model="editForm"
      >
        <el-row :gutter="20">
          <el-col :lg="8" :md="12">
            <el-form-item label="Note Type" prop="noteType">
              <el-select style="width: 100%" v-model="editForm.noteType">
                <el-option
                  v-for="item in noteTypeList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="editForm.noteType === 3">
            <el-col :lg="8" :md="12">
              <el-form-item label="Financial Report Type" prop="reportType">
                <el-select
                  v-model="editForm.reportType"
                  style="width: 100%"
                  placeholder="Select Financial Report Type"
                >
                  <el-option
                    v-for="item in addFormReportTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :lg="8" :md="12">
              <el-form-item label="Financial Report Time" prop="reportTime">
                <el-date-picker
                  v-model="editForm.reportTime"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
          </template>
          <el-col :lg="8" :md="12">
            <el-form-item label="Note Name" prop="noteName">
              <el-input
                type="textarea"
                maxlength="500"
                show-word-limit
                v-model="editForm.noteName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="Copy Notes to" prop="copyNotesTo">
              <el-checkbox-group :max="1" v-model="editForm.tick">
                <el-checkbox :label="1">Ultimate Customer</el-checkbox>
                <el-checkbox :label="2">All Group Customer</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="Comments">
              <quill-editor
                :initContent="editForm.remark"
                ref="quillEditor"
                :token="token"
              ></quill-editor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!--      <multi-file-upload :file-list="fileList" ref="uploadComponent" />-->
      <el-upload
        action=""
        multiple
        :auto-upload="false"
        :limit="15"
        :on-exceed="handleExceed"
        :file-list="CFileList"
        :show-file-list="false"
        :on-change="handleChange"
      >
        <customize-button>Upload Documents</customize-button>
      </el-upload>
      <ul class="file-list">
        <li
          class="list-item"
          v-for="(item, index) in CFileList"
          :key="index"
          @click="handleDownload(item)"
        >
          {{ item.name }}
          <el-popconfirm
            title="Confirm to delete？"
            confirm-button-text="confirm"
            cancel-button-text="cancel"
            @confirm="handleRemoveItem(item, index)"
          >
            <a href="javascript: void (0)" @click.stop slot="reference">
              Delete
            </a>
          </el-popconfirm>
        </li>
      </ul>
    </el-card>
    <div style="margin-top: 20px; text-align: right">
      <customize-button style="margin-right: 20px" @click="handleCancel">
        Cancel
      </customize-button>
      <customize-button type="primary" @click="handleSave">
        Save
      </customize-button>
    </div>
  </div>
</template>
<script>
import { noteTypeList, getDetailedData } from './api'
import QuillEditor from 'components/quill-editor/QuillEditor.vue'
import { commonDownload, commonRemoveFile, commonUpload } from '@/api'
const UPLOAD_READY = 'ready'
export default {
  components: {
    QuillEditor,
  },
  data() {
    return {
      noteTypeList: noteTypeList,
      editForm: {
        id: '',
        noteType: '',
        remark: '',
        companyId: this.$route.params.customerId,
        noteName: '',
        tick: [],
        reportType: '',
        reportTime: '',
      },
      addFormReportTypeList: [
        { value: 1, label: 'Annual Report' },
        { value: 2, label: 'Interim Report' },
      ],
      fileList: [],
      editRules: {
        noteType: [
          {
            required: true,
            message: 'must can not be empty!',
            trigger: 'change',
          },
        ],
        noteName: [
          {
            required: true,
            message: 'must can not be empty!',
            trigger: 'blur',
          },
        ],
        reportType: [
          {
            required: true,
            message: 'Can not be empty!',
            trigger: 'change',
          },
        ],
        reportTime: [
          {
            required: true,
            message: 'Can not be empty!',
            trigger: 'change',
          },
        ],
      },
      CFileList: [],
      acceptFileTypes: [
        'png',
        'gif',
        'pjp',
        'jpg',
        'jpeg',
        'bmp',
        'csv',
        'xlsm',
        'xltm',
        'ico',
        'xls',
        'xlsx',
        'doc',
        'docx',
        'pdf',
        'ppt',
        'pptx',
        'txt',
        'rar',
        'zip',
        'html',
        'msg',
      ],
      downloadUrl: '',
      token: '',
    }
  },
  methods: {
    async handleRemoveItem({ id }, index) {
      if (id) {
        await commonRemoveFile(id)
        this.$message.success('success')
      }
      this.CFileList.splice(index, 1)
    },
    handleDownload(raw) {
      const { id } = raw
      if (!this.downloadUrl && id) {
        commonDownload(id)
      }
    },
    handleChange(file) {
      // 判断文件后缀格式
      const _index = file.name.lastIndexOf('.')
      const _type = file.name.substr(_index + 1)
      if (this.acceptFileTypes.indexOf(_type) === -1) {
        this.$message.error(`.${_type} is invalid`)
        this.CFileList = [...this.CFileList]
        return
      }
      // 单个文件不能超过50M
      const fileSize = Number(file.size / 1024 / 1024)
      if (file.status === UPLOAD_READY && fileSize < 50) {
        this.CFileList.push(file)
      } else {
        this.$message.error('File must not exceed 50M')
        this.CFileList = [...this.CFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
      }
    },
    handleExceed() {
      this.$message.warning(
        'Maximum fifteen files can be uploaded. Each file cannot exceed 50M.',
      )
    },
    handleCancel() {
      this.$refs.editForm.resetFields()
      this.fileList = []
      this.$router.go(-1)
    },
    async initData() {
      const params = {
        companyId: this.$route.params.id,
      }
      const data = await getDetailedData(params)
      if (data.remark?.includes('&gt;') || data.remark?.includes('&lt;')) {
        data.remark = data.remark.replace(/&gt;/g, '>')
        data.remark = data.remark.replace(/&lt;/g, '<')
      }
      this.editForm = {
        ...this.editForm,
        id: data.id,
        noteType: data.noteType,
        remark: data.remark,
        noteName: data.noteName,
        tick: data.tick ? [data.tick] : [],
        reportType: data.reportType || '',
        reportTime: data.reportTime || '',
      }
      this.CFileList = [...data.files]
    },
    async handleUpload() {
      const fileList = this.CFileList
      const resetFileList = fileList.filter(file => !file.id)
      const formData = new FormData()
      resetFileList.forEach(item => {
        formData.append('file', item.raw)
      })
      Object.keys(this.editForm).forEach(key => {
        if (key === 'remark') {
          formData.append('remark', this.$refs.quillEditor.getContent().trim())
        } else if (key === 'tick') {
          formData.append(
            'tick',
            this.editForm.tick.length ? this.editForm.tick[0] : 0,
          )
        } else {
          formData.append(key, this.editForm[key])
        }
      })
      return await commonUpload(formData)
    },
    async handleSave() {
      const valid = await this.$refs.editForm.validate()
      if (valid) {
        const id = await this.handleUpload()
        if (id) {
          this.$message.success('success')
          this.$router.go(-1)
        }
      }
    },
  },
  created() {
    this.initData()
    this.token = this.$storage.getItem('token')
  },
}
</script>
<style scoped lang="scss">
.file-list {
  margin-top: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    line-height: 30px;
    padding: 0 10px;
    border-radius: 8px;

    &:hover {
      background-color: #e2e2e5;
    }
  }
}
</style>
